import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate, I18n } from "react-redux-i18n";
import { validateEmail } from "../../utils/Utils";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import axios, { CancelToken } from "axios";

import { setAlert } from "../../../actions/alertActions";
import { verifyEditedAccountCode } from "../../../actions/accountActions";

import "../../../styles/components/account/manageAccount/verifyAccount.scss";
import evio from "../../../styles/images/evio.svg";

class VerifyEditedAccount extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      validated: false,
      email: "",
      emailIsValid: false,
      emailIsTouched: false,

      code: "",
      codeIsValid: false,
      codeIsTouched: false,
    };

    this.handleVerifyCode = this.handleVerifyCode.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.validateFormOnBlur = this.validateFormOnBlur.bind(this);
    this.validateOverallForm = this.validateOverallForm.bind(this);
    this.resendCode = this.resendCode.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props?.tempEmail) {
      this.safeSetState({
        email: this.props.tempEmail,
        emailIsValid: true,
        emailIsTouched: true,
      });
    }
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value.trim(),
    });
  }

  validateFormOnBlur(e) {
    if (e.target.name === "code") {
      this.safeSetState({ codeIsTouched: true }, () => {
        if (this.state.code.trim() !== "") {
          this.safeSetState(
            {
              codeIsValid: true,
            },
            this.validateOverallForm()
          );
        } else if (this.state.code.trim() === "") {
          this.safeSetState(
            {
              codeIsValid: false,
            },
            this.validateOverallForm()
          );
        }
      });
    } else if (e.target.name === "email") {
      this.safeSetState({ emailIsTouched: true }, () => {
        if (!validateEmail(this.state.email)) {
          this.safeSetState(
            {
              emailIsValid: false,
            },
            this.validateOverallForm()
          );
        } else if (validateEmail(this.state.email)) {
          this.safeSetState(
            {
              emailIsValid: true,
            },
            this.validateOverallForm()
          );
        }
      });
    }
  }

  validateOverallForm(callback) {
    if (
      this.state.emailIsValid &&
      this.state.codeIsValid &&
      this.state.codeIsTouched &&
      this.state.emailIsTouched
    ) {
      this.safeSetState(
        {
          validated: true,
        },
        callback
      );
    }
  }

  handleVerifyCode(e) {
    e.preventDefault();
    const form = e.target;

    this.validateOverallForm(() => {
      if (this.state.validated && form.checkValidity() !== false) {
        const elements = form.elements;
        const email = this.state.email;
        const code = elements.code.value.trim();

        this.props.verifyEditedAccountCode(email, code);
      }
    });
  }

  resendCode(e) {
    e.preventDefault();

    const patch = {
      internationalPrefix: "",
      mobile: "",
      email: this.state.email,
    };

    axios
      .patch("/api/accountActivation/resendCode", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.props.setAlert(
          I18n.t("verificationEditedAccount_resendCode"),
          "primary"
        );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="verifyAccount" className="evio-container">
        <div className="sidemenu">
          <div className="logo-container">
            <img src={evio} alt="EVIO logo" />
          </div>
          <div className="form-container">
            <Form
              id="verification-form"
              validated={this.state.validated}
              noValidate
              onSubmit={this.handleVerifyCode}
            >
              <Form.Group className="form-field">
                <p>
                  <Translate value="signUpVerification_subTitle" />
                </p>
              </Form.Group>
              <Form.Group className="info-field">
                <Form.Control
                  type="text"
                  name="email"
                  placeholder={I18n.t("componentVerificationEmail_Email")}
                  value={this.state.email}
                  onChange={this.handleOnChange}
                  onBlur={this.validateFormOnBlur}
                  required
                />
                {!this.state.emailIsValid && this.state.emailIsTouched && (
                  <p className="error-text">
                    <Translate value="componentVerificationEmail_invalidEmail" />
                  </p>
                )}
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Control
                  type="text"
                  name="code"
                  placeholder={I18n.t("componentVerificationCode_code")}
                  onChange={this.handleOnChange}
                  onBlur={this.validateFormOnBlur}
                  minLength="1"
                  required
                />
              </Form.Group>
              <span onClick={this.resendCode} className="sendCode">
                {`${I18n.t("componentVerificationCode_didnGetCode")} ${I18n.t(
                  "signUpVerification_codeSentAgain"
                )}`}
              </span>
              {!this.state.codeIsValid && this.state.codeIsTouched && (
                <p className="error-text">
                  <Translate value="componentVerificationCode_invalidCode " />
                </p>
              )}
            </Form>
          </div>
          <div className="footer-container">
            <button type="submit" form="verification-form">
              <Translate value="componentButton_verify" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  verifyEditedAccount: state.account.verifyEditedAccount,
  verifyResendCode: state.account.verifyResendCode,
  accountData: state.account.accountData,
  tempEmail: state.account.tempEmail,
});

export default connect(mapStateToProps, {
  verifyEditedAccountCode,
  setAlert,
})(VerifyEditedAccount);
